import React from "react";
import NotFoundPageStyles from './NotFoundPage.module.scss';
import {useNavigate} from "react-router-dom";

const NotFoundPage = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className={NotFoundPageStyles.notFoundContainer}>
            <img src="/notFound.svg" alt="notFound" className={NotFoundPageStyles.notFoundImage}/>

            <div
                onClick={handleGoHome}
                className={NotFoundPageStyles.homeButton}
            >
                Вернуться на главную
            </div>
        </div>
    );
};

export default NotFoundPage;